<template>
  <div class="PersonVacationListWeb">
    <v-data-table
      dense
      :disable-sort="true"
      :headers="headers"
      :items="list"
      :item-class="row_classes"
      :hide-default-footer="!pagination"
      :disable-pagination="!pagination"
      @click:row="handleClick"
    >
      <template v-slot:header.select="{}">
        <v-checkbox
          dense
          hide-details="true"
          v-model="isCheckAll"
          @change="checkAll()"
        ></v-checkbox>
      </template>
      <template v-slot:item.select="{ item }">
        <v-checkbox
          dense
          hide-details="true"
          v-model="item.select"
          @click.stop=""
        ></v-checkbox>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    approved:Boolean,
    list: Array,
    pagination: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    list() {
      this.selectedList = [];
    },
  },
  data() {
    return {
      isCheckAll: false,
      selectedList: [],
      headers: [
        {
          text: this.$t("card-no"),
          value: "perno",
        },
        {
          text: this.$t("person-name"),
          value: "personName",
        },
        {
          text: this.$t("BeginDate"),
          value: "BEGINDATE",
        },
        {
          text: this.$t("BeginTime"),
          value: "BEGINTIME",
        },
        {
          text: this.$t("EndDate"),
          value: "ENDDATE",
        },
        {
          text: this.$t("EndTime"),
          value: "ENDTIME",
        },
        {
          text: this.$t("RequestDate"),
          value: "requestDate",
        },
        {
          text: this.$t("status"),
          value: "Statustype",
        },
        {
          text: this.$t("description"),
          value: "Dscp",
        },
        {
          text: this.$t(""),
          value: "select",
        },
      ],
    };
  },
  mounted() {
    this.checkApproved();

  },
  methods: {
    checkAll() {
      var list = [...this.list];
      if (this.isCheckAll) {
        list.forEach((element) => {
          element.select = true;
        });
      } else {
        list.forEach((element) => {
          element.select = false;
        });
      }

      this.list = list;
    },
    handleClick(value) {
      this.$emit("onClick", value);
    },
    row_classes(item) {
      if (item.isGroup == 1) {
        return "bg-green"; //can also return multiple classes e.g ["orange","disabled"]
      }
    },
    checkApproved(){
      debugger
      if(this.approved){
       
        this.headers.splice(8)
      }
    },
  },
};
</script>

<style>
</style>